import { render, staticRenderFns } from "./WarningPop.vue?vue&type=template&id=5066a986&scoped=true&"
import script from "./WarningPop.vue?vue&type=script&lang=js&"
export * from "./WarningPop.vue?vue&type=script&lang=js&"
import style0 from "./WarningPop.vue?vue&type=style&index=0&id=5066a986&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5066a986",
  null
  
)

export default component.exports